import React, { useState } from 'react';
import { FaUsersBetweenLines } from 'react-icons/fa6';
import { LiaUsersCogSolid } from 'react-icons/lia';
import { MdGroups2 } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import VendorsHome from '../components/Vendors/VendorsHome';
import VendorsGroups from '../components/Vendors/groups/VendorsGroups';
import { CardHeadeWithActions } from '../components/ui';

const Vendors = () => {
    const [tabActive, setTabActive] = useState('vendors');
    const { t } = useTranslation('global');

    const currentTabTitle =
        tabActive === 'vendors' ? t('vendors.vendors') : t('vendors.vendorGroups');

    return (
        <div className='overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm'>
            <CardHeadeWithActions
                title={t('vendors.manageVendors')}
                icon={<LiaUsersCogSolid size={22} />}
            >
                <span className='rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-500'>
                    {currentTabTitle}
                </span>
            </CardHeadeWithActions>

            <div className='bg-slate-50 p-3 md:p-4'>
                <div id='Tabs' className='grid grid-cols-1 gap-3 border-b border-slate-200 pb-4 md:grid-cols-2'>
                    <div
                        onClick={() => setTabActive('vendors')}
                        className={`flex flex-col items-center justify-center gap-2 rounded-2xl border p-4 text-slate-500 transition-all hover:bg-indigo-50 hover:text-indigo-800 ${
                            tabActive === 'vendors'
                                ? 'border-indigo-200 bg-indigo-100 text-indigo-800 shadow-sm'
                                : 'border-slate-200 bg-white'
                        }`}
                    >
                        <FaUsersBetweenLines size={28} />
                        <span className='text-sm font-medium'>{t('vendors.vendors')}</span>
                    </div>

                    <div
                        onClick={() => setTabActive('Groups')}
                        className={`flex flex-col items-center justify-center gap-2 rounded-2xl border p-4 text-slate-500 transition-all hover:bg-indigo-50 hover:text-indigo-800 ${
                            tabActive === 'Groups'
                                ? 'border-indigo-200 bg-indigo-100 text-indigo-800 shadow-sm'
                                : 'border-slate-200 bg-white'
                        }`}
                    >
                        <MdGroups2 size={28} />
                        <span className='text-sm font-medium'>{t('vendors.vendorGroups')}</span>
                    </div>
                </div>

                <div className='pt-4 text-xs text-slate-500'>
                    {tabActive === 'vendors' && <VendorsHome />}
                    {tabActive === 'Groups' && <VendorsGroups />}
                </div>
            </div>
        </div>
    );
};

export default Vendors;
